import React from 'react';
import { Button, Form, Input, TextArea, Segment, Grid } from 'semantic-ui-react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets';
import moment from 'moment';
import { ToastContainer, toast } from 'react-toastify';
import { fetchAcademicYears, fetchCurrentAcademicYear } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class InternshipForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dateStart: new Date(),
            dateEnd: new Date(),
            academicYear: null,
            durationHours: 120,
            institutionName: '',
            mentor: '',
            comment: '',
            academicYearOptions: [],


        };
        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }


    componentDidMount() {
        if (this.props.edit) {
            let studentInternshipObject = JSON.parse(localStorage.getItem('studentInternshipObject'));
            let {
                institutionName, academicYear, comment, optLock, id, dateStart, dateEnd, durationHours, mentor
            } = studentInternshipObject;
            this.setState({
                institutionName, dateStart: new Date(dateStart), dateEnd: new Date(dateEnd), durationHours, academicYear: academicYear.id, comment, internshipId: id, optLock, mentor
            });
        }

        fetchAcademicYears()
            .then(res => {
                const academicYearOptions = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                })).reverse();
                this.setState({ academicYearOptions });
            })
            .catch(err => {
                console.log('Failed to fetch academicYearOptions.');
            });
    }

    addInternship() {
        if (!this.state.institutionName || !this.state.academicYear || !this.state.dateStart || !this.state.dateEnd || !this.state.durationHours || !this.state.mentor) {
            toast('Niste unijeli sva obavezna polja!');

            if (!this.state.institutionName) { this.setState({ institutionNameErr: true }); } else { this.setState({ institutionNameErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.dateStart) { this.setState({ dateStartErr: true }); } else { this.setState({ dateStartErr: false }); }
            if (!this.state.dateEnd) { this.setState({ dateEndErr: true }); } else { this.setState({ dateEndErr: false }); }
            if (!this.state.durationHours) { this.setState({ durationHoursErr: true }); } else { this.setState({ durationHoursErr: false }); }
            if (!this.state.mentor) { this.setState({ mentorErr: true }); } else { this.setState({ mentorErr: false }); }
        } else {
            let obj = {
                studentStudyProgram: { id: this.props.studentStudyProgramId },
                institutionName: this.state.institutionName,
                durationHours: this.state.durationHours,
                mentor: this.state.mentor,
                academicYear: { id: this.state.academicYear },
                dateStart: moment(this.state.dateStart).format(),
                dateEnd: moment(this.state.dateEnd).format(),
                comment: this.state.comment,

            };
            axios.post('student-study-program-internship/save', { ...obj })
                .then(ress => {
                    toast('Dodavanje prakse je uspješno izvršeno.');
                })
                .then(res => {
                    this.props.closeForm();
                    this.props.getInternships();
                })
                .catch(err => {
                    if (err.response.data === 'Internship for this academic year is already added!') {
                        toast('Praksa za odabranu godinu već postoji.');
                    } else {
                        toast('Došlo je do greške! Dodavanje prakse nije uspješno izvršeno.');
                    }
                });
        }
    }

    editInternship() {
        if (!this.state.institutionName || !this.state.academicYear || !this.state.dateStart || !this.state.dateEnd || !this.state.durationHours || !this.state.mentor) {
            toast('Niste unijeli sva obavezna polja!');

            if (!this.state.institutionName) { this.setState({ institutionNameErr: true }); } else { this.setState({ institutionNameErr: false }); }
            if (!this.state.academicYear) { this.setState({ academicYearErr: true }); } else { this.setState({ academicYearErr: false }); }
            if (!this.state.dateStart) { this.setState({ dateStartErr: true }); } else { this.setState({ dateStartErr: false }); }
            if (!this.state.dateEnd) { this.setState({ dateEndErr: true }); } else { this.setState({ dateEndErr: false }); }
            if (!this.state.durationHours) { this.setState({ durationHoursErr: true }); } else { this.setState({ durationHoursErr: false }); }
            if (!this.state.mentor) { this.setState({ mentorErr: true }); } else { this.setState({ mentorErr: false }); }
        } else {
            let obj = {
                studentStudyProgram: { id: this.props.studentStudyProgramId },
                optLock: this.state.optLock,
                id: this.state.internshipId,
                institutionName: this.state.institutionName,
                durationHours: this.state.durationHours,
                mentor: this.state.mentor,
                academicYear: { id: this.state.academicYear },
                dateStart: moment(this.state.dateStart).format(),
                dateEnd: moment(this.state.dateEnd).format(),
                comment: this.state.comment,
            };
            axios.put('student-study-program-internship/edit', { ...obj })
                .then(ress => {
                    toast('Izmjena podataka o praksi je uspješno izvršena.');
                })
                .then(res => {
                    this.props.closeForm();
                    this.props.getInternships();
                })
                .catch(err => {
                    if (err.response.data === 'This internship has been already changed!') {
                        toast('Podaci o praksi su prethodno izmijenjeni.');
                    } else {
                        toast('Došlo je do greške! Izmjena podataka nije uspješno izvršena.');
                    }
                });
        }
    }

    handleChange(name, date) {
        if (name === 'dateEnd') {
            if (date < this.state.dateStart) {
                toast('Datum kraja mora biti poslije datuma početka!');
                return;
            }
        }

        if (name === 'dateStart') {
            if (date > this.state.dateEnd) {
                toast('Datum početka mora biti prije datuma kraja!');
                return;
            }
        }
        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    render() {
        return (
            <div>
                <Segment secondary clearing>
                    <Form>
                        <Form.Group widths="equal">
                            <Form.Field
                                required
                                error={this.state.institutionNameErr}
                                label="Naziv institucije"
                                control={Input}
                                name="institutionName"
                                value={this.state.institutionName}
                                onChange={this.handleInputChange}
                                placeholder="Unesite naziv"
                            />
                            <Form.Field required error={this.state.academicYearErr} >
                                <label>Akademska godina</label>
                                <Form.Dropdown
                                    clearable
                                    selection
                                    disabled={this.props.edit}
                                    placeholder="Odaberite semestre"
                                    value={this.state.academicYear}
                                    onChange={this.handleInputChange}
                                    name="academicYear"
                                    options={this.state.academicYearOptions}
                                    search
                                    fluid
                                />
                            </Form.Field>
                            <Form.Field
                                required
                                error={this.state.mentorErr}
                                label="Mentor"
                                control={Input}
                                name="mentor"
                                value={this.state.mentor}
                                onChange={this.handleInputChange}
                                placeholder="Unesite ime i prezime"
                            />

                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field>
                                <label>Datum početka</label>
                                <DateTimePicker
                                    defaultValue={new Date()}
                                    format="D. M. YYYY."
                                    time={false}
                                    onChange={this.handleChange.bind(null, 'dateStart')}
                                    value={this.state.dateStart}
                                    placeholder="Unesite datum u formatu D. M. GGGG."
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Datum kraja</label>
                                <DateTimePicker
                                    defaultValue={new Date()}
                                    format="D. M. YYYY."
                                    time={false}
                                    onChange={this.handleChange.bind(null, 'dateEnd')}
                                    value={this.state.dateEnd}
                                    placeholder="Unesite datum u formatu D. M. GGGG."
                                />
                            </Form.Field>

                            <Form.Field
                                required
                                error={this.state.durationHoursErr}
                                label="Trajanje(sati)"
                                control={Input}
                                name="durationHours"
                                type="number"
                                value={this.state.durationHours}
                                onChange={this.handleInputChange}
                                placeholder="Unesite trajanje"
                            />

                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Field
                                label="Napomena"
                                control={TextArea}
                                // rows={5}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                                placeholder="Unesite napomenu..."
                            />
                        </Form.Group>

                        <Button
                            basic="true"
                            color="blue"
                            floated="right"
                            onClick={this.props.closeForm}
                        >
                            Odustani
                        </Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={this.props.edit ? () => this.editInternship() : () => this.addInternship()}
                        >
                            {this.props.edit ? 'Izmijeni' : 'Dodaj'}
                        </Button>
                        <br />
                        <br />
                    </Form>
                </Segment>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/InternshipForm.js